import * as React from "react";
import { observer } from "mobx-react";
import { Checkbox } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import { useRootStore } from "../../../store/contexts";
import Button from "@mui/material/Button";
import { KeyboardArrowDownIcon } from "../../../icons";
import { VisibilityOffIcon } from "../../../icons";
export type ColumnChooserProps = {
  columns: { name: string; isHidden: boolean; label: string }[];
  onChoose: (name: string) => void;
  columnsMenu: boolean;
  setColumnsMenu: (visible: boolean) => void;
};

export const ColumnChooser: React.FC<ColumnChooserProps> = observer(
  ({ columns, onChoose, columnsMenu, setColumnsMenu }) => {
    const open = Boolean(columnsMenu);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
      setColumnsMenu(Boolean(event.currentTarget));
    };
    const handleClose = () => {
      setColumnsMenu(false);
    };

    const rootStore = useRootStore();
    const { langStore } = rootStore;

    const theme = useTheme();
    const fgColor = `${theme.palette.primary.contrastText}`;

    const handleChoose = (value: string) => {
      onChoose(value);
    };

    return (
      <div>
        <Button
          id="column-chooser-button"
          aria-controls={open ? "column-chooser-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          startIcon={<VisibilityOffIcon />}
          disableElevation
          onClick={handleClick}
          endIcon={<KeyboardArrowDownIcon />}
        >
          {langStore.columnsChooserLabel}
        </Button>

        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          variant={"standard"}
          value={[{ label: "", name: "" }]}
          disableUnderline
          IconComponent={() => null}
          MenuProps={{
            anchorOrigin: {
              vertical: 35,
              horizontal: -90,
            },
          }}
          open={open}
          onClose={handleClose}
          sx={{
            notchedOutline: { border: "none", borderColor: "transparent" },
            fontSize: 14,
            fontWeight: 500,
            color: fgColor,
            width: 0,
          }}
        >
          {columns.map((item) => {
            return (
              <MenuItem key={item.name}>
                <Checkbox
                  checked={!item.isHidden}
                  onChange={() => handleChoose(item.name)}
                />
                <ListItemText
                  primary={item.label}
                  onClick={() => handleChoose(item.name)}
                />
              </MenuItem>
            );
          })}
        </Select>
      </div>
    );
  }
);
